export const IS_SERVER_SIDE = typeof window === 'undefined'
export const IS_SSR_ENABLED = parseInt(process.env.NEXT_PUBLIC_SSR_ENABLED) == 1
export const IS_SSR = IS_SERVER_SIDE && IS_SSR_ENABLED

// console.log({ IS_SSR, IS_SSR_ENABLED, IS_SERVER_SIDE })

export const getServerSideProps = async () => {
  return { props: {} }
}
